export const ActivateSubscriptionCancelModal: string = 'ActivateSubscriptionSuccessCanceModal';
